/**
 * Waiting-room Assign Practitioner conflict (HTTP 409) from encounter or queue.
 */
export const getAssignConflictDetails = (error) => {
  const data = error?.response?.data;
  const status = error?.response?.status;
  const isConflict =
    status === 409 || data?.code === "QUEUE_ASSIGN_CONFLICT";

  if (!isConflict) {
    return null;
  }

  return {
    message:
      data?.message || "This encounter is already assigned to another practitioner",
    assignedTo: data?.assignedTo || null,
  };
};

export const formatAssignConflictToast = (details, capitalizeName) => {
  const name = details?.assignedTo?.display;
  if (name) {
    const formatted = capitalizeName ? capitalizeName(name) : name;
    return `Already assigned to ${formatted}`;
  }
  return details?.message || "This encounter is already assigned to another practitioner";
};
